import { VisuallyHidden } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * This component is a hidden status message that announces the selected option to screen readers.
 */
export var A11yStatusMessage = _ref => {
  var {
    selectedOption
  } = _ref;
  var [message, setMessage] = useState(null);
  useEffect(() => {
    if (!selectedOption) return;
    setMessage("".concat(selectedOption.label, " has been selected"));
    var timeoutId = setTimeout(() => setMessage(null), 300);
    return () => clearTimeout(timeoutId);
  }, [selectedOption]);
  return /*#__PURE__*/_jsx(VisuallyHidden, {
    "data-component": "SelectNew.A11yStatusMessage",
    id: "a11y-status-message",
    role: "status",
    "aria-live": "polite",
    "aria-relevant": "additions text",
    children: message
  });
};
A11yStatusMessage.displayName = 'SelectNew.A11yStatusMessage';
//# sourceMappingURL=A11yStatusMessage.js.map